import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "column flex-center sfx-progress" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-quote-text" }, "/", -1)
const _hoisted_3 = {
  key: 2,
  class: "row items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-quote-text" }, "/", -1)

import { Icons } from "src/util/enums/fontAwesomeIcons"
import {
  ProgressIndicatorMode,
  ProgressIndicatorState,
} from "src/util/types/components/sfxProgressIndicator"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

type ProgressIndicatorProperties = {
  circleSize: string
  percentClass: string
  chipClass: string
  numbersClass: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxProgressIndicator',
  props: {
  current: {
    required: true,
    type: Number,
  },

  total: {
    required: true,
    type: Number,
  },

  mode: {
    type: String as PropType<ProgressIndicatorMode>,
    default: "condensed",
  },

  state: {
    type: String as PropType<ProgressIndicatorState>,
    default: "draft",
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const isDraftState = computed<boolean>(() => props.state === "draft")
const percentage = computed<number>(() => (props.current / props.total) * 100)

const progressIndicatorValue = computed<number | undefined>(() =>
  isDraftState.value ? undefined : props.total ? Math.floor(percentage.value) : 0
)

const displayValue = computed<string>(() => progressIndicatorValue.value?.toString() ?? "-")

const stateLabel = computed<string>(() => t(`sfxProgressIndicator.${props.state}`))

const currentStateLabelClass = computed<string>(() => {
  switch (props.state) {
    case "draft":
      return "bg-disabled-back"
    case "closed":
      return "bg-inactive"
    case "complete":
      return "bg-positive"
    case "complete_closed":
      return "bg-blue-900"
    default:
      return "bg-fun-label-and-icon"
  }
})

const specialIconRight = computed<string>(() => {
  switch (props.state) {
    case "closed":
      return Icons.WORK_ORDER_CLOSED_UNCOMPLETED
    case "complete":
    case "complete_closed":
      return Icons.WORK_ORDER_COMPLETED
    default:
      return ""
  }
})

const CONDENSED_PROPERTIES: ProgressIndicatorProperties = {
  percentClass: "sfx-progress-text-condensed",
  circleSize: "56px",
  chipClass: "text-h6",
  numbersClass: "text-caption",
} as const

const TECHNICIAN_PROPERTIES: ProgressIndicatorProperties = {
  percentClass: "text-h4",
  circleSize: "96px",
  chipClass: "text-h6",
  numbersClass: "text-caption",
} as const

const MANAGER_PROPERTIES: ProgressIndicatorProperties = {
  percentClass: "sfx-progress-text-manager",
  circleSize: "168px",
  chipClass: "sfx-progress-chip--manager text-h5",
  numbersClass: "text-h4 text-weight-bold",
} as const

const componentProperties = computed<ProgressIndicatorProperties>(() => {
  switch (props.mode) {
    case "condensed":
    default:
      return CONDENSED_PROPERTIES
    case "technician":
      return TECHNICIAN_PROPERTIES
    case "manager":
      return MANAGER_PROPERTIES
  }
})

const circularProgressColor = computed(() => (props.total >= props.current ? "info" : "negative"))

const circularProgressClass = computed(() => {
  return { "text-negative": props.current > props.total }
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_circular_progress, _mergeProps({
      reverse: "",
      class: circularProgressClass.value,
      color: circularProgressColor.value,
      "track-color": "line-and-filler",
      size: componentProperties.value.circleSize,
      thickness: 0.37,
      value: progressIndicatorValue.value,
      "show-value": ""
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["sfx-progress-value", componentProperties.value.percentClass])
        }, _toDisplayString(displayValue.value) + "% ", 3)
      ]),
      _: 1
    }, 16, ["class", "color", "size", "value"]),
    (props.state)
      ? (_openBlock(), _createBlock(_component_q_chip, {
          key: 0,
          class: _normalizeClass(["sfx-progress-chip", [currentStateLabelClass.value, componentProperties.value.chipClass]]),
          ripple: false,
          square: "",
          label: stateLabel.value,
          "icon-right": specialIconRight.value,
          "text-color": "white"
        }, null, 8, ["label", "icon-right", "class"]))
      : _createCommentVNode("", true),
    (isDraftState.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["justify-center", componentProperties.value.numbersClass])
        }, [
          _createTextVNode(" - "),
          _hoisted_2,
          _createTextVNode(" - ")
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (props.current > props.total)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: _unref(Icons).WARNING,
                color: "negative",
                class: "q-mr-xs"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(componentProperties.value.numbersClass)
          }, [
            _createTextVNode(_toDisplayString(props.current) + " ", 1),
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(props.total), 1)
          ], 2)
        ]))
  ]))
}
}

})